// MonitoringList.jsx — proc-v3 (F2.3g): OTTAVA VISTA DEL MONOLITE in React,
// "Monitoraggio di mercato", flag-gated (shell_proc_v3_monitoring, default OFF).
// PRIMA vista sul SECONDO componente condiviso del design system (CardGrid):
// la vista v1 è una card-grid (grid-cols-1 lg:grid-cols-2), NON tabellare —
// scartata dall'ondata 21 proprio per questo.
//
// Replica 1:1 renderMonitoring di proc-v0.js:12023-12137: stesso titolo/
// sottotitolo/bottone (hardcoded IT nel v1 — MON_TEXTS VERBATIM in api.js),
// stesso banner ambra sulle pianificazioni in scadenza, stesse card
// (badge target/stato, scadenze relative in giorni, rotazione identità con
// '← next', anteprima fornitori, footer azioni). Ordine card = store
// (nessun sort client, come il v1).
//
// AZIONI: modali complesse DELEGATE alle globali v1 (openScheduleModal,
// _confirmRunSchedule, _showScheduleHistory); Pausa/Riprendi ed Elimina =
// STESSE primitive confirmWrite del v1 (payload identici, F1T5), redraw con
// rerenderAll (api.js). CONFINI (pattern f23c): product-detail = V1;
// MAI 'nav:badge' da questo modulo.

import React from 'react';
import { CardGrid } from '../ui/CardGrid.jsx';
import {
  MON_TEXTS, readMonitoring, monDueBanner, monDueLabel,
  monOpenNew, monOpenEdit, monOpenProduct,
  monRun, monHistory, monToggleStatus, monDelete,
} from './api.js';

// Etichetta target della card (v1:12056-12058): categoria → code col path,
// prodotto → link al product-detail, prodotto sparito → 'Product missing'.
function TargetLabel({ win, s }) {
  if (s._isCategory) {
    return (
      <>
        {MON_TEXTS.categoryPrefix}
        <code className="bg-slate-100 px-1 rounded text-[11px]">{s.categoryPath || '?'}</code>
      </>
    );
  }
  if (s._productName != null) {
    return (
      <>
        {MON_TEXTS.productPrefix}
        <button
          type="button"
          className="text-cyan-700 hover:underline mon-open-prod"
          onClick={() => monOpenProduct(win, s.productId)}
        >{s._productName}</button>
      </>
    );
  }
  return <span className="text-rose-700">{MON_TEXTS.productMissing}</span>;
}

// Scadenza relativa colorata (v1:12063-12066).
function DueLabel({ due }) {
  if (due.kind === 'none') return <>{MON_TEXTS.noDue}</>;
  if (due.kind === 'overdue') return <span className="text-rose-700 font-semibold">{monDueLabel(due)}</span>;
  if (due.kind === 'today') return <span className="text-amber-700 font-semibold">{monDueLabel(due)}</span>;
  return <span className="text-slate-500">{monDueLabel(due)}</span>;
}

// Contenuto card (v1:12073-12121) — il CHROME lo mette CardGrid (.cg-card).
// NB PARITÀ TESTUALE (stessa classe del bug 2 di f23f): il template literal
// v1 lascia NODI-SPAZIO (newline+indent) tra gli elementi ⇒ il textContent
// normalizzato ha uno spazio a ogni confine. Il JSX NON li produce da sé:
// i {' '} espliciti qui sotto replicano quei nodi (in flex/grid i nodi di
// solo whitespace non generano box: zero differenza visiva).
function ScheduleCard({ win, s }) {
  return (
    <>
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="font-semibold text-base">{s.name || MON_TEXTS.untitled}</h3>
            {' '}
            {s._isCategory
              ? <span className="bg-purple-100 text-purple-800 text-[10px] px-2 py-0.5 rounded uppercase tracking-wider">{MON_TEXTS.badgeCategory}</span>
              : <span className="bg-cyan-100 text-cyan-800 text-[10px] px-2 py-0.5 rounded uppercase tracking-wider">{MON_TEXTS.badgeProduct}</span>}
            {' '}
            {s.status === 'paused'
              ? <span className="bg-slate-200 text-slate-600 text-xs px-2 py-0.5 rounded">{MON_TEXTS.statusPaused}</span>
              : <span className="bg-emerald-100 text-emerald-800 text-xs px-2 py-0.5 rounded">{MON_TEXTS.statusActive}</span>}
          </div>
          {' '}
          <div className="text-xs text-slate-500 mt-0.5">
            <TargetLabel win={win} s={s} />
            {MON_TEXTS.cadenceMid}{String(s.cadenceMonths)}{MON_TEXTS.cadenceTail}
          </div>
        </div>
        {' '}
        <button
          type="button"
          className="mon-edit text-xs text-slate-500 hover:text-slate-900"
          onClick={() => monOpenEdit(win, s.id)}
        >{MON_TEXTS.editBtn}</button>
      </div>
      {' '}
      <div className="grid grid-cols-2 gap-3 text-xs mb-3">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-slate-500">{MON_TEXTS.nextCycleH}</div>
          {' '}
          <div className="mt-0.5"><DueLabel due={s._due} /></div>
          {' '}
          <div className="text-[10px] text-slate-400 mt-0.5">{s._nextDueDate}</div>
        </div>
        {' '}
        <div>
          <div className="text-[10px] uppercase tracking-wider text-slate-500">{MON_TEXTS.lastCycleH}</div>
          {' '}
          <div className="mt-0.5">
            {s._lastRunDate != null ? s._lastRunDate : <span className="text-slate-400 italic">{MON_TEXTS.neverRun}</span>}
          </div>
          {s._lastIdName ? <>{' '}<div className="text-[10px] text-slate-400 mt-0.5">{MON_TEXTS.viaPrefix}{s._lastIdName}</div></> : null}
        </div>
      </div>
      {' '}
      <div className="bg-slate-50 border border-slate-200 rounded p-2 text-xs mb-3">
        <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-1">
          {MON_TEXTS.rotationPrefix}{s.rotationStrategy}{')'}
        </div>
        {' '}
        <div className="flex flex-wrap gap-1">
          {s._identities.length ? s._identities.map((idn) => (
            <span
              key={idn.iid}
              className={'px-2 py-0.5 rounded text-[11px] ' + (idn.isNext ? 'bg-cyan-200 text-cyan-900 font-semibold' : 'bg-white border border-slate-200 text-slate-700')}
            >
              {idn.name}
              {idn.email ? <span className="text-slate-500">{' <' + idn.email + '>'}</span> : null}
              {idn.isNext ? MON_TEXTS.nextMarker : null}
            </span>
          )) : <span className="text-slate-400 italic">{MON_TEXTS.noIdentities}</span>}
        </div>
      </div>
      {' '}
      <div className="text-xs text-slate-500 mb-3">
        <strong>{s._supCount}{MON_TEXTS.suppliersWord}</strong>
        {MON_TEXTS.contactedText}{s._supNames.join(', ')}
        {s._supCount > 3 ? MON_TEXTS.morePrefix + (s._supCount - 3) + MON_TEXTS.moreSuffix : null}
      </div>
      {' '}
      <div className="flex gap-2">
        <button type="button" className="mon-run bg-cyan-700 hover:bg-cyan-800 text-white px-3 py-1.5 rounded text-xs" onClick={() => monRun(win, s.id)}>{MON_TEXTS.runBtn}</button>
        {' '}
        <button type="button" className="mon-toggle bg-slate-200 hover:bg-slate-300 text-slate-700 px-3 py-1.5 rounded text-xs" onClick={() => monToggleStatus(win, s.id)}>
          {s.status === 'active' ? MON_TEXTS.pauseBtn : MON_TEXTS.resumeBtn}
        </button>
        {' '}
        <button type="button" className="mon-history text-xs text-slate-500 hover:text-slate-900 ml-auto" onClick={() => monHistory(win, s.id)}>
          {MON_TEXTS.historyPrefix}{s._historyCount}{')'}
        </button>
        {' '}
        <button type="button" className="mon-del text-xs text-rose-600 hover:text-rose-800" onClick={() => monDelete(win, s.id)}>{MON_TEXTS.deleteBtn}</button>
      </div>
    </>
  );
}

export function MonitoringList({ win, tick }) {
  // dati: letti dallo store del monolite a ogni refresh (tick dal wrapper) —
  // stessa composizione del v1 (api.readMonitoring)
  const data = React.useMemo(() => readMonitoring(win), [win, tick]);

  return (
    <div>
      <div className="flex items-start justify-between mb-4">
        <div>
          <h1 className="text-2xl font-bold">{MON_TEXTS.title}</h1>
          <p className="text-sm text-slate-500 mt-0.5 max-w-3xl">{MON_TEXTS.subtitle}</p>
        </div>
        <button
          id="btn-new-schedule"
          type="button"
          className="bg-slate-900 hover:bg-slate-800 text-white px-3 py-1.5 rounded text-sm"
          onClick={() => monOpenNew(win)}
        >{MON_TEXTS.newBtn}</button>
      </div>

      {data.dueCount ? (
        <div className="bg-amber-50 border border-amber-200 rounded p-3 mb-4 text-sm">
          <strong className="text-amber-900">{monDueBanner(data.dueCount)}</strong>
          {' '}
          <span className="text-amber-800">{MON_TEXTS.bannerSpan}</span>
        </div>
      ) : null}

      <div id="mon-list">
        <CardGrid
          items={data.rows}
          itemKey="id"
          twoColAt="lg"
          renderCard={(s) => <ScheduleCard win={win} s={s} />}
          emptyMessage={MON_TEXTS.emptyMessage}
        />
      </div>
    </div>
  );
}

// Factory (pattern createProcV3Tags): il register/install la aggancia al
// WRAP di window.renderMonitoring. render() idempotente sul container;
// unmount() libera il container (il monolite resta vivo per le altre viste).
export function createProcV3Monitoring(win) {
  let root = null;
  let mountedEl = null;
  let tick = 0;

  function render() {
    const container = win.document.getElementById('monitoring-content');
    if (!container) throw new Error('#monitoring-content assente');
    if (!root || mountedEl !== container || !container.isConnected) {
      if (root) { try { root.unmount(); } catch (e) { /* già smontato */ } }
      container.replaceChildren(); // eventuali resti del v1 (catch-up)
      root = win.ReactDOM.createRoot(container);
      mountedEl = container;
    }
    tick += 1; // ogni chiamata del wrapper = refresh dati (rerenderAll, toggle, rientro)
    root.render(<MonitoringList win={win} tick={tick} />);
  }

  function unmount() {
    if (root) {
      try { root.unmount(); } catch (e) { /* già smontato */ }
      root = null;
    }
    mountedEl = null;
  }

  function isMounted() { return !!root; }

  return { render, unmount, isMounted };
}
